import styled from 'styled-components'

export const Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 64px;

  a {
    text-decoration: none;
    color: inherit;
    flex: 1;
    max-width: 300px;
  }
`

export const FoodItemContainer = styled.div`
  flex: 1;
  max-width: 300px;
  text-align: center;
  box-shadow: 0rem 0.5rem 2rem rgb(0 0 0 / 20%);
  border-radius: 5px;
  font-weight: bold;
  transition: 0.5s;
  padding: 15px;

  &:hover {
    box-shadow: 0rem 0.5rem 1.5rem rgb(0 0 0 / 30%);
    //transform: scale(1.01);
  }

  span {
    font-size: 12px;
  }

  p {
    margin-bottom: 0;
  }
`

export const Image = styled.img`
  object-fit: cover;
  height: 200px;
  flex-basis: min-content;
  width: 100%;
  box-shadow: 0rem 0.5rem 2rem rgb(0 0 0 / 20%);
  border-radius: 5px;
`

export const ImageContainer = styled.div`
  position: relative;
`

export const ButtonsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0 32px;
`
